import actions from './actions';

const initialState = {
  data: [],
  url: null,
  fileLoading: false, 
  loading: false,
  error: null,
};

const volunteerApplicantsInitialState = {
  data: [],
  url: null,
  fileLoading: false, 
  loading: false,
  error: null,
};

const volunteerApplicationsReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {

    case actions.VOLUNTEER_APPLICATIONS_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case actions.VOLUNTEER_APPLICATIONS_READ_SUCCESS:
      return {
        ...state,
        data, 
        error: false,
        loading: false,
      };
    case actions.VOLUNTEER_APPLICATIONS_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

const volunteerApplicantsReducer = (state = volunteerApplicantsInitialState, action) => {
  const { type, data, err } = action;
  switch (type) {

    case actions.VOLUNTEER_APPLICANTS_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case actions.VOLUNTEER_APPLICANTS_READ_SUCCESS:
      return {
        ...state,
        data, 
        error: false,
        loading: false,
      };
    case actions.VOLUNTEER_APPLICANTS_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

export { volunteerApplicationsReducer, volunteerApplicantsReducer };
